interface IUpdateVendorInfo {
  fullName: string;
  email: string;
  phone: string;
  address: string;
  companyName: string;
  code: string | null;
  country: string | null;
  addressState: string | null;
  addressCountry: string | null;
}

interface UpdateStatusInfo {
  complaintUuid: string;
  status: string;
  companyUuid: string;
}

async function getVendorLogin(vendorUuid: string) {
  const response = await fetch(process.env.REACT_APP_API_URL + `vendor/${vendorUuid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  });
  const data = await response.json();
  return data;
}

async function updateVendor(vendorLoginDetail: IUpdateVendorInfo) {
  const response = await fetch(process.env.REACT_APP_API_URL + `vendor/update-profile`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    },

    body: JSON.stringify(vendorLoginDetail)
  });
  return response;
}

async function getVendorComplaintList(
  vendorUuid: string,
  page: number,
  limit: number,
  type: string,
  search: string,
  from: string,
  to: string,
  sort: string
) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}vendor/complaint-list?vendorUuid=${vendorUuid}&type=${type}&search=${search}&from=${from}&to=${to}&page=${page}&limit=${limit}&sort=${sort}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );
  const data = await response.json();
  return data;
}

async function updateComplaint(complaintDetails: UpdateStatusInfo) {
  const response = await fetch(process.env.REACT_APP_API_URL + `vendor/update-status`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    },
    body: JSON.stringify(complaintDetails)
  });
  return response;
}

export { getVendorLogin, updateVendor, getVendorComplaintList, updateComplaint };
